var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.332 4.99936V7.01602C18.332 8.33269 17.4987 9.16602 16.182 9.16602H13.332V3.34102C13.332 2.41602 14.0904 1.66602 15.0154 1.66602C15.9237 1.67436 16.757 2.04102 17.357 2.64102C17.957 3.24936 18.332 4.08269 18.332 4.99936Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83269V17.4993C1.66797 18.191 2.4513 18.5827 3.0013 18.166L4.4263 17.0993C4.75964 16.8493 5.2263 16.8827 5.5263 17.1827L6.90964 18.5743C7.23464 18.8993 7.76797 18.8993 8.09297 18.5743L9.49297 17.1743C9.78463 16.8827 10.2513 16.8493 10.5763 17.0993L12.0013 18.166C12.5513 18.5743 13.3346 18.1827 13.3346 17.4993V3.33269C13.3346 2.41602 14.0846 1.66602 15.0013 1.66602H5.83464H5.0013C2.5013 1.66602 1.66797 3.15769 1.66797 4.99936V5.83269Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 11.4406L9.77656 6.89062",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93555 11.25H9.94303",
    stroke: "#D08759",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16211 7.08398H5.16959",
    stroke: "#D08759",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.e3b4b43efeac22c0672de8e7d0eeaf7e.svg";
export { ForwardRef as ReactComponent };